module.exports = __webpack_public_path__ + "img/AD.f37d608f.png";